export type AppEnv = 'localhost' | 'dev' | 'sand' | 'demo' | 'prod';

/**
 * Gets the runtime environment variable from window.env or process.env
 * @param key - The environment variable key to get
 * @param fallback - The fallback value to return if the environment variable is not found
 * @returns The environment variable value
 */
export const getRuntimeEnv = (key: string, fallback: string = ''): string => {
  if (typeof window !== 'undefined' && window.env && key in window.env) {
    return window.env[key];
  }

  // Fallback for SSR/tests
  if (process.env[key]) {
    return process.env[key] as string;
  }

  return fallback;
};

/**
 * Checks if the current app environment matches a specific value
 * @param env - The environment value to check against
 * @returns true if the current app environment matches the provided value
 */
export const isAppEnv = (env: AppEnv): boolean => {
  const currentEnv = getRuntimeEnv('BE_ENV', 'localhost');
  return currentEnv === env;
};
